import { Observable, of } from 'rxjs';
import { Environment } from '@ipreo/bd-external-participants';
import { environment } from '@env/environment';

export class ExternalParticipantsProvider {
  getEnvironment(): Observable<Environment> {
    return of(environment.externalParticipantEnvironment);
  }
}
